import React, { useContext, useState } from 'react';
import styles from './bizmax.module.css';
import { CommonButton } from '~/common/components/CommonButton';
import { gtagEnvelope } from '~/common/util/gtagEnvelope';
import { Trial } from '~/common/pages/Trial/Trial';
import { CONTENT_IDS, TRIAL_TYPES } from '~/common/consts';
import { TrialContentProvider } from '~/common/provider/TrialContentProvider';
import { ModalContentContext } from '~/common/context/ContentContext';
import { useAppStore } from '~/common/store/appStore';
import { useShallow } from 'zustand/react/shallow';

const BizMax = () => {
  const { setContentId, trialType, setTrialType, setBusinessMax } = useAppStore(
    useShallow((state) => ({
      setContentId: state.setContentId,
      trialType: state.trialType,
      setTrialType: state.setTrialType,
      setBusinessMax: state.setBusinessMax,
    }))
  );
  const [currentStep, setCurrentStep] = useState<number>(0);
  const data = useContext(ModalContentContext);

  const handleCallback = (step: number) => {
    gtagEnvelope('event', 'cta_click', {
      cta_name: 'Step change',
      cta_position: `Chevy Trial Modal - Business - Step ${step}`,
    });
    setCurrentStep(step);
  };

  const handlePersonalClick = () => {
    gtagEnvelope('event', 'cta_click', {
      cta_name: 'Next',
      cta_position: 'Chevy Trial Modal - Business Max',
    });
    setContentId(CONTENT_IDS.BUSINESS);
    setTrialType(TRIAL_TYPES.BUSINESS);
    setCurrentStep(1);
    setBusinessMax(true);
  };

  const handleBusinessClick = () => {
    gtagEnvelope('event', 'cta_click', {
      cta_name: 'Next',
      cta_position: 'Chevy Trial Modal - Business',
    });
    setContentId(CONTENT_IDS.BUSINESS);
    setTrialType(TRIAL_TYPES.BUSINESS);
    setCurrentStep(1);
  };

  if (!data) {
    return (
      <div className={styles['modal-cards']}>
        <div className={styles['modal-card']}>
          <div className={`${styles.contentLine} ${styles.contentLineImage}`}></div>
          <div className={styles['modal-card-copy']}>
            <div className={`${styles.contentLine} ${styles.contentLine28}`}></div>
            <div className={`${styles.contentLine} ${styles.contentLine50}`}></div>
            <div className={`${styles.contentLine} ${styles.contentLine50}`}></div>
            <div className={`${styles.contentLine} ${styles.contentLineButton}`}></div>
          </div>
        </div>
        <div className={styles['modal-card']}>
          <div className={`${styles.contentLine} ${styles.contentLineImage}`}></div>
          <div className={styles['modal-card-copy']}>
            <div className={`${styles.contentLine} ${styles.contentLine28}`}></div>
            <div className={`${styles.contentLine} ${styles.contentLine50}`}></div>
            <div className={`${styles.contentLine} ${styles.contentLine50}`}></div>
            <div className={`${styles.contentLine} ${styles.contentLineButton}`}></div>
          </div>
        </div>
      </div>
    );
  }

  return currentStep === 0 ? (
    <div className={styles['modal-cards']}>
      <div className={styles['modal-card']}>
        <div className={styles['modal-card-illustration']}>
          <img
            src={'https://www.lastpass.com/-/media/687b4bd8b49d4376a56daaba6e9490db.jpg'}
            alt="Business illustration"
          />
        </div>
        <div className={styles['modal-card-copy']}>
          <h4>Business</h4>
          <p>Designed for businesses of all sizes, from small startups to enterprises.</p>
          <CommonButton stylesModifier="black" onClick={handleBusinessClick}>
            Try Business free
          </CommonButton>
        </div>
      </div>

      <div className={styles['modal-card']}>
        <div className={styles['modal-card-illustration']}>
          <img
            src={'https://www.lastpass.com/-/media/fca920a05aed4888ab9708f1feed6f12.jpg'}
            alt="Business Max illustration"
          />
        </div>
        <div className={styles['modal-card-copy']}>
          <h4>Business Max</h4>
          <p>Designed for lean IT teams who need simple, browser-based control over every app and every login.</p>
          <CommonButton stylesModifier="black" onClick={handlePersonalClick}>
            Try Business Max free
          </CommonButton>
        </div>
      </div>
    </div>
  ) : (
    <div className={styles['modal-cols']}>
      <div className={styles['modal-col1']}>
        <div className={styles['step-indicators']}>
          <button className={styles.active}>1</button>
          <div className={`${styles['step-indicators-line']} ${currentStep === 2 ? styles.active : ''}`}></div>
          <button className={currentStep === 2 ? styles.active : ''}>2</button>
        </div>
        <TrialContentProvider>
          <Trial handleCallback={handleCallback} modalContent={data} />
        </TrialContentProvider>
      </div>
      <div
        className={styles['modal-col2']}
        style={{ backgroundColor: trialType === TRIAL_TYPES.BUSINESS ? '#a5c1dc' : '#DEECDB' }}
      >
        <img src={trialType === TRIAL_TYPES.BUSINESS ? data.secondStep?.image : data.secondStep?.image2} alt="Trial" />
      </div>
    </div>
  );
};

export default BizMax;
